import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation  } from "react-router-dom";
import ResponsiveAppBar from "./components/ResponsiveAppBar";
import UserDataSync from "./authMethods/UserDataSync.js";
import ResponsiveChessPage from "./components/ResponsiveChessPage.js";
import MainPage from "./components/MainPage.js";
import ResponsiveChessPageLearn from "./components/ResponsiveChessPageLearn.js";
import Test from "./components/Test.js"
import SupportWidget from "./components/SupportWidget"; // already imported
import { useWebSocket } from "./services/WebSocketProvider.js";
import UserGames from "./components/UserGames.js";
import WelcomePage from "./components/WelcomePage.js";
import Favorites from "./components/Favorites.js";
import { useWebSocketManager } from "./services/useWebSocketManager";
import SettingsPage from "./components/SettingsPage.js"
import ChartsPage from "./components/ChartsPage.js"
import SignUp from "./components/SignUp.js";
import SignIn from "./components/SignIn.js";
import { useUser } from "./authMethods/UserContext";
import { GENERAL } from "./general/General";
import { Analytics } from "@vercel/analytics/react";
import DemocraticChessOverview from "./components/DemocraticChessOverview.js";
import TeamBuilder from "./components/TeamBuilder.js";
import TeamPlay from "./components/TeamPlay";
import ReportIssueForm from "./components/ReportIssueForm.js";
import NotEnoughCoinsDialog from "./components/NotEnoughCoinsDialog.js";
import AccountPage from "./components/AccountPage.js";
import { initGA, trackPageView } from "./ga";
import { sendMessage } from "./services/websocketManager";
import { generalMessageTemplate } from "./entities/generalMessageTemplate";
import useStartAppRedirect from "./hooks/useStartAppRedirect.js"
import ResponsiveChessPageBlind from "./components/ResponsiveChessPageBlind.js"; // Import the blind version of the app bar
import DropIn from "./components/DropIn"; // new component
import LottieLoaderPage from "./components/LottieLoaderPage";
import LichessAnalysisPage from "./components/LichessAnalysisPage"
import UnifiedChessAnalytics from "./components/UnifiedChessAnalytics"; // Import the unified analytics component
import { TourProvider } from './components/TourProvider';
import TourOverlay from './components/TourOverlay';
import ChessGameAnalysis from "./components/ChessGameAnalysis.js"; // Import the analysis component

const App = () => {
  useStartAppRedirect();
  const location = useLocation();
  const { connectionStatus, generalMessage } = useWebSocketManager();
  const { userData } = useUser();
  const { showHistoryLimitDialog, setShowHistoryLimitDialog } = useWebSocket();
  //const shouldShowAppBar = !((location.pathname === "/chess") ); // Hide AppBar // || (location.pathname === "/main")
  const [showAppBar, setShowAppBar] = useState(true); // Initial state is true

  useEffect(() => {
    initGA();
    if (window.Telegram && window.Telegram.WebApp) {
      const tg = window.Telegram.WebApp;
      tg.ready();      // Signal that app is ready
      tg.expand();     // Expand to full screen
      //console.log("Telegram init data:", tg.initDataUnsafe);
      const initData = tg.initDataUnsafe;
      //console.log("Telegram Init Data:", initData);

      if (initData?.user?.id) {
      // const telegramUser = {
      //   id: initData.user.id,
      //   first_name: initData.user.first_name,
      //   last_name: initData.user.last_name,
      //   username: initData.user.username,
      //   photo_url: initData.user.photo_url,
      // };
     
      const generalMessage = {
              ...generalMessageTemplate,
              user: {
                ...generalMessageTemplate.user,
                id: initData.user.id,
                firstName: initData.user.first_name,
                secondName: initData.user.last_name,
                userName: initData.user.username,
                
                url: initData.user.photo_url,
              },
              messageType: "telegram_auth",
            };
      
            sendMessage(generalMessage);
    }
    }
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  const [background, setBackground] = useState({
    
    size: "cover",
    position: "center",
    zIndex: -1, // Places it behind all other elements
  });

  return (
    <div
      className="background-container"
      style={{
        backgroundImage: `url(${background.image})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      {/* 🎯 TourProvider now wraps EVERYTHING that uses tours */}
      <TourProvider>
        {/* Conditional rendering for AppBar - NOW INSIDE TourProvider */}
        {showAppBar && (
          <div
            style={{
              position: "relative",
              top: 0,
              width: "100%",
              zIndex: 1000,
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <ResponsiveAppBar
              websocketStatus={connectionStatus}
              userData={userData}
            />
            <UserDataSync />
          </div>
        )}

        <div
          style={{
            display: "flex",
            //flex: 2,
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "0px",
            overflow: "hidden", // Prevent scrolling
          }}
        >
          
          <NotEnoughCoinsDialog
            open={showHistoryLimitDialog}
            onClose={() => setShowHistoryLimitDialog(false)}
            userData={userData}
            buy={true}
          />
          
          <Routes>
           
            <Route path="/" element={<Navigate to="/welcome" />} />
            <Route
              path="/main"
              element={
                <MainPage
                  userData={userData}
                  updateBackground={setBackground}
                  setShowAppBar={setShowAppBar}
                />
              }
            />
            <Route
              path="/chess"
              element={
                <ResponsiveChessPage
                  generalMessage={generalMessage}
                  updateBackground={setBackground}
                  userData={userData}
                  setShowAppBar={setShowAppBar}
                />
              }
            />
            <Route
              path="/settings"
              element={<SettingsPage updateBackground={setBackground} />}
            />

            <Route
              path="/blind"
              element={<ResponsiveChessPageBlind updateBackground={setBackground} setShowAppBar={setShowAppBar} />}
            />

             <Route
              path="/chat"
              element={<ChessGameAnalysis  updateBackground={setBackground} setShowAppBar={setShowAppBar} />}
            />

            <Route
              path="/charts"
              element={<ChartsPage updateBackground={setBackground} />}
            />
            <Route
              path="/contactus"
              element={<ReportIssueForm updateBackground={setBackground} />}
            />
            <Route
              path="/team-builder"
              element={<TeamBuilder updateBackground={setBackground} />}
            />
            <Route
              path="/account"
              element={<AccountPage purchasedPackages={userData?.coinsPackages || []} />}
            />
            <Route
              path="/team-play"
              element={
                <TeamPlay
                  updateBackground={setBackground}
                  setShowAppBar={setShowAppBar}
                />
              }
            />
            <Route
              path="/invited/:invitationId/:invitePlayerColor"
              element={
                <ResponsiveChessPage
                  generalMessage={generalMessage}
                  updateBackground={setBackground}
                  viewer={true}
                  userData={userData}
                  setShowAppBar={setShowAppBar}
                />
              }
            />
            {/* <Route path="/" element={<WelcomePage friendId={friendId} />} /> */}
            
            <Route
              path="/about"
              element={
                <DemocraticChessOverview
                  userData={userData}
                  updateBackground={setBackground}
                />
              }
            />
            <Route
              path="/learn"
              element={
                <ResponsiveChessPageLearn
                  userData={userData}
                  updateBackground={setBackground}
                  setShowAppBar={setShowAppBar}
                />
              }
            />
            <Route path="/test" element={<DropIn />} />

            <Route
              path="/welcome"
              element={
                <WelcomePage
                  userData={userData}
                  updateBackground={setBackground}
                />
              }
            />
          <Route
              path="/signup"
              element={<SignUp updateBackground={setBackground} />}
            />
            <Route
              path="/login"
              element={<SignIn updateBackground={setBackground} />}
            />
            <Route
              path="/favorites"
              element={
                <Favorites userData={userData} updateBackground={setBackground} />
              }
            />
            <Route
              path="/games"
              element={
                <UserGames userData={userData} updateBackground={setBackground} />
              }
              
            />
            <Route path="/analysis" element={<UnifiedChessAnalytics updateBackground={setBackground}/>} />
            <Route path="/loader" element={<LottieLoaderPage />} />
          </Routes>
           
          {/* Tour overlay - NOW INSIDE TourProvider, will appear on all pages when tour is active */}
          <TourOverlay />
        </div>
      </TourProvider>
      
      <SupportWidget /> {/* ✅ Global placement, works on all pages */}
      {/* Add Vercel Analytics */}
      <Analytics />
    </div>
  );
};

export default App;